<div class="row mb-3">
  <div class="col-md-3 col-lg-2 left-menu">
    <div *ngFor="let item of menu" class="menu">
      <li class="menu-item" (click)="redirectTo(item)" [ngClass]="{'focus_menu': menuAdmin === item.url}">
        {{item.title}}
      </li>
    </div>
  </div>
  <div class="col-md-9 col-lg-10 pr-0">
    <router-outlet></router-outlet>
  </div>
</div>